import { useState } from 'react';
import { useSearchParams } from 'react-router';
import {
  JobPostingSortableField,
  JobPostingStatus,
  useGetJobPostings,
} from '~/domain/PermanentJobs';
import { IFilterFormData } from './components';
import { TSortValue } from '~/commonComponents';

const DEFAULT_SORTING = {
  direction: 'DESC',
  field: JobPostingSortableField.PublishedAt,
};

const isValidJobPostingStatus = (value: string | null): value is JobPostingStatus =>
  Object.values(JobPostingStatus).includes(value as JobPostingStatus);

export const useManageJobs = () => {
  const [searchParams] = useSearchParams();
  const statusParam = searchParams.get('status');
  const initialStatus = isValidJobPostingStatus(statusParam)
    ? statusParam
    : JobPostingStatus.Active;

  const [formFilters, setFormFilters] = useState<IFilterFormData>({
    officeId: '',
    profession: 'all',
    status: initialStatus,
  });
  const [formSorting, setFormSorting] = useState<TSortValue>(DEFAULT_SORTING);
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isInitialLoading, isLoading, pagination, statistics } = useGetJobPostings({
    officeId: formFilters.officeId,
    orderBy: formSorting.field as JobPostingSortableField,
    orderDirection: formSorting.direction,
    page: currentPage,
    professionType: formFilters.profession === 'all' ? undefined : formFilters.profession,
    status: formFilters.status,
    subProfessionType: formFilters.subProfession,
  });

  const handleSetFormSorting = (value: TSortValue | undefined) => {
    setFormSorting(value === undefined ? DEFAULT_SORTING : value);
  };

  return {
    data: data,
    initialStatus,
    forms: {
      filters: formFilters,
      sorting: formSorting,
    },
    isInitialLoading,
    isLoading,
    methods: {
      setCurrentPage,
      setFormFilters,
      setFormSorting: handleSetFormSorting,
    },
    pagination: {
      currentPage: currentPage,
      totalPages: pagination.totalPages,
    },
    statistics,
  };
};
